module.exports = __webpack_public_path__ + "img/22.85cf46cd.jpg";